import React from 'react';

import FitmentTab from './components/fitment-tab/fitment-tab';
import Tabs from '../../../tabs/tabs';
import { TABS } from '../../fitment-constants';

interface FitmentTabsProps {
  hideTabs?: boolean | string[];
  onTabSelected?: (label: string) => void;
  selectedTab?: string;
}

function FitmentTabs(props: FitmentTabsProps) {
  const { hideTabs, onTabSelected, selectedTab } = props;

  function isTabHidden(tab) {
    return Array.isArray(hideTabs) && hideTabs.indexOf(tab) !== -1;
  }

  if (Boolean(hideTabs) && !Array.isArray(hideTabs)) {
    return null;
  }

  return (
    <Tabs>
      {!isTabHidden(TABS.VEHICLE) && (
        <FitmentTab
          label={TABS.VEHICLE}
          onClick={onTabSelected}
          selectedTab={selectedTab}
        />
      )}
      {!isTabHidden(TABS.SIZE) && (
        <FitmentTab
          label={TABS.SIZE}
          onClick={onTabSelected}
          selectedTab={selectedTab}
        />
      )}
      {!isTabHidden(TABS.BRAND) && (
        <FitmentTab
          label={TABS.BRAND}
          onClick={onTabSelected}
          selectedTab={selectedTab}
        />
      )}
    </Tabs>
  );
}

export default FitmentTabs;
